import React from 'react';
import {
    FaArrowUp
} from 'react-icons/fa';
import '../../App.css';

const Footer = () => {
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="main-footer">
            <div className="footer-left">
                <button className="scroll-top-btn" onClick={scrollToTop}>
                    <FaArrowUp/>
                </button>
            </div>

            <div className="footer-center">
                © 2026 ·
                Verum†

            </div>

            <div className="footer-right">
                All rights reserved
            </div>
        </div>

    );
};

export default Footer;
